// extracted by mini-css-extract-plugin
export default {"ButtonDark":"ButtonDark_ButtonDark__62zex","ButtonDarkArrow":"ButtonDark_ButtonDarkArrow__J+gPZ"};